import {Component, inject, OnDestroy, OnInit, ViewEncapsulation, Input} from "@angular/core";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {ActivatedRoute, Router, RouterLink, RouterOutlet} from "@angular/router";
import {DavesaFullscreenComponent} from "@davesa/components/fullscreen";
import {DavesaLoadingBarComponent} from "@davesa/components/loading-bar";
import {DavesaNavigationService, DavesaVerticalNavigationComponent} from "@davesa/components/navigation";
import {DavesaMediaWatcherService} from "@davesa/services/media-watcher";
import {NavigationService} from "app/core/navigation/navigation.service";
import {Navigation} from "app/core/navigation/navigation.types";
import {LanguagesComponent} from "app/layout/common/languages/languages.component";
import {SearchComponent} from "app/layout/common/search/search.component";
import {ShortcutsComponent} from "app/layout/common/shortcuts/shortcuts.component";
import {LoginUserComponent} from "app/layout/common/login-user/login-user.component";
import {Subject, takeUntil} from "rxjs";
import {UserMenuComponent} from "app/layout/common/user-menu/user-menu.component";
import {ClinicNowComponent} from "app/layout/common/clinic-now/clinic-now.component";
import {SupportLinksComponent} from "app/layout/common/support-links/support-links.component";
import {DavesaAlertBannerComponent} from "@davesa/components/alert-banner";
import {SettingsComponent} from "app/layout/common/settings/settings.component";
import { GlobalSearchComponent } from "app/layout/common/global-search/global-search.component";
import { NotificationsComponent } from "app/layout/common/notifications/notifications.component";
import { PasswordExpiryBannerComponent } from "app/shared/components/password-expiry-banner/password-expiry-banner.component";

@Component({
    selector: "classy-layout",
    templateUrl: "./classy.component.html",
    encapsulation: ViewEncapsulation.None,
    imports: [
        RouterLink,
        DavesaLoadingBarComponent,
        DavesaVerticalNavigationComponent,
        NotificationsComponent,
        LoginUserComponent,
        UserMenuComponent,
        MatIconModule,
        MatButtonModule,
        // LanguagesComponent,
        DavesaFullscreenComponent,
        GlobalSearchComponent,
        ShortcutsComponent,
        // MessagesComponent,
        RouterOutlet,
        // DavesaAlertBannerComponent,
        ClinicNowComponent,
        SupportLinksComponent,
        // SettingsComponent,
        PasswordExpiryBannerComponent
    ]
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
    @Input() showClinicNow: boolean = true;
    isScreenSmall: boolean;
    navigation: Navigation;
    imageUrl: string;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        // private _userService: UserService,
        private _davesaMediaWatcherService: DavesaMediaWatcherService,
        private _davesaNavigationService: DavesaNavigationService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((navigation: Navigation) => {
            this.navigation = navigation;
        });

        // this.imageUrl = this.user.profile_img_url;
        // this.imageUrl = 'images/avatars/tom-powell.jpg';
        this.imageUrl = null;
        // Subscribe to media changes
        this._davesaMediaWatcherService.onMediaChange$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(({matchingAliases}) => {
            // Check if the screen is small
            this.isScreenSmall = !matchingAliases.includes("md");
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._davesaNavigationService.getComponent<DavesaVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
